import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import ReactSelect from '../../common/ReactSelect';
import { importsActions } from '../../../data/actions/imports';

class StatementPeriodDates extends React.Component {
	
	constructor(props){
		super(props);
		this.state = {
		}
	}
	
	componentDidMount() {
		this.props.dispatch(importsActions.getStatementPeriodDates());
	}
	

	render() {
		const { imports : { periodDatesLoading, periodDates } , onSelectDate } = this.props;
		return <ReactSelect  className="single-select" options={periodDates} onChange={onSelectDate} loading={periodDatesLoading} placeholder="Please choose report period" />
	}
}


function mapStateToProps(state) {
	return {
		imports: state.imports
	} 
}

export default connect(mapStateToProps)(StatementPeriodDates);